import {elementNameConst, shapeTypeConst, stateConst} from '../../conf';

/**
 * 拓扑插件-节点相关逻辑
 */


/**
 * 拓扑插件-公共函数-处理计算图形大小
 * @param size 图形大小
 * @returns attr 图形大小
 */
export function handleCommonSizeCompute(size) {
  let width = 60, height = 60;
  if (typeof size === 'number') {
    width = size;
    height = size;
  } else if (size instanceof Array) {
    width = size[0];
    height = size[1];
  }
  return {width, height};
}


/**
 * 拓扑插件-公共函数-处理节点各状态样式
 * @param stateName 状态名称，如：active
 * @param status 状态，true或false
 * @param node 节点
 * @returns style 节点状态样式
 */
export function handleStateStyle(stateName, status, node) {

  let stateStyle = node.getStateStyle(stateName);

  const active = node.hasState(stateConst.active);
  if (active) {
    return node.getStateStyle(stateConst.active);
  }

  const selected = node.hasState(stateConst.selected);
  if (selected) {
    return node.getStateStyle(stateConst.selected);
  }

  const disable = node.hasState(stateConst.disable);
  if (disable) {
    return node.getStateStyle(stateConst.disable);
  }

  const error = node.hasState(stateConst.error);
  if (error) {
    return node.getStateStyle(stateConst.error);
  }

  const warning = node.hasState(stateConst.warning);
  if (warning) {
    return node.getStateStyle(stateConst.warning);
  }

  if (!status) {
    stateStyle = node.getStateStyle(stateConst.defaultState);
  }
  return stateStyle;
}


/**
 * 拓扑插件-节点-处理添加背景图片图形
 * @param that vue实例
 * @param url 背景图片URL地址
 * @returns shape 背景图片图形对象
 */
export function handleAddBackgroundImage(that, url) {
  const stage = that.getCanvasStage();
  let bgImage = getBgImageShape(that);
  if (!bgImage) {
    bgImage = stage.getGroup().addShape(shapeTypeConst.image, {
      attrs: {
        id: elementNameConst.defaultBgImageShapeId,
        name: elementNameConst.defaultBgImageShapeName,
        width: stage.getWidth(),
        height: stage.getHeight(),
        img: url
      },
      capture: false,
      zIndex: 1
    });
    bgImage.toBack();
  } else {
    bgImage.attr({img: url});
  }
  return bgImage;
}


/**
 * 拓扑插件-节点-处理删除背景图片图形
 * @param that vue 实例
 */
export function handleRemoveBackgroundImage(that) {
  const rootGroup = that.getCanvasStage().getGroup();
  const bgImage = getBgImageShape(that);
  rootGroup.removeChild(bgImage);
}


/**
 * 拓扑插件-节点-处理背景图片图形重置尺寸大小
 * @param that vue 实例
 * @param width 新的宽度
 * @param height 新的高度
 */
export function handleBackgroundImageResize(that, width, height) {
  const bgImage = getBgImageShape(that);
  if (bgImage) {
    bgImage.attr({width: width, height: height});
  }
}


/**
 * 拓扑插件-节点-处理添加背景颜色图形
 * @param that vue实例
 * @param color 背景颜色值
 * @returns shape 背景颜色图形对象
 */
export function handleAddBackgroundColor(that, color) {
  const stage = that.getCanvasStage();
  let bgColor = getBgColorShape(that);
  if (!bgColor) {
    bgColor = stage.getGroup().addShape(shapeTypeConst.rect, {
      attrs: {
        id: elementNameConst.defaultBgColorShapeId,
        name: elementNameConst.defaultBgColorShapeName,
        width: stage.getWidth(),
        height: stage.getHeight(),
        fill: color
      },
      capture: false,
      zIndex: 0
    });
    bgColor.toBack();
  } else {
    bgColor.attr({fill: color});
  }
  return bgColor;
}


/**
 * 拓扑插件-节点-处理删除背景颜色图形
 * @param that vue 实例
 */
export function handleRemoveBackgroundColor(that) {
  const rootGroup = that.getCanvasStage().getGroup();
  const bgColor = getBgColorShape(that);
  rootGroup.removeChild(bgColor);
}


/**
 * 拓扑插件-节点-处理背景颜色图形重置尺寸大小
 * @param that vue 实例
 * @param width 新的宽度
 * @param height 新的高度
 */
export function handleBackgroundColorResize(that, width, height) {
  const bgColor = getBgColorShape(that);
  if (bgColor) {
    bgColor.attr({width: width, height: height});
  }
}


/**
 * 拓扑插件-节点-处理背景颜色图形重置尺寸大小
 * @param that vue 实例
 * @param width 新的宽度
 * @param height 新的高度
 */
export function handleBackgroundShapeResize(that, width, height) {
  // 背景图片
  handleBackgroundImageResize(that, width, height);
  // 背景颜色
  handleBackgroundColorResize(that, width, height);
}


/**
 * 拓扑插件-节点-获取背景颜色图形
 * @param that vue 实例
 * @returns shape 背景颜色图形
 */
export function getBgColorShape(that) {
  const rootGroup = that.getCanvasStage().getGroup();
  return rootGroup.find(item => item.constructor.name !== shapeTypeConst.group && item.attr().id === elementNameConst.defaultBgColorShapeId);
}


/**
 * 拓扑插件-节点-获取背景图片图形
 * @param that vue 实例
 * @returns shape 背景图片图形
 */
export function getBgImageShape(that) {
  const rootGroup = that.getCanvasStage().getGroup();
  return rootGroup.find(item => item.constructor.name !== shapeTypeConst.group && item.attr().id === elementNameConst.defaultBgImageShapeId);
}


/**
 * 拓扑插件-节点-获取节点尺寸
 * @param item 节点模型
 */
export function getShapeSize(item) {
  let width = item?.width || 0;
  let height = item?.height || 0;

  if (!item) {
    return {width, height};
  }

  if (width === 0 || height === 0) {
    width = item.getModel()?.width || 0;
    height = item.getModel()?.height || 0;
  }

  if ((width === 0 || height === 0) && item.getModel()) {
    const sizeObj = handleCommonSizeCompute(item.getModel().size);
    width = sizeObj?.width || 0;
    height = sizeObj?.height || 0;
  }

  if ((width === 0 || height === 0) && item?.attr()) {
    width = item.attr().width || 0;
    height = item.attr().height || 0;
  }

  return {width, height};
}


/**
 * 拓扑插件-节点-删除节点状态指定样式
 * @param item 节点对象
 * @param options 待删除样式，数组
 */
export function handleDeleteStateStyle(item, ...options) {
  if (!item) {
    return;
  }

  const props = ['fill', 'stroke', 'lineWidth', ...options];
  props.forEach(field => {
    delete item._cfg.styles.active[field];
    delete item._cfg.styles.selected[field];
  });
}


/**
 * 拓扑插件-节点-处理节点配置中各类自定义参数，例如：字体图标加背景色块
 * @param model 图形参数模型
 */
export function handleNodeAttr(model) {

  // 补充避免 idField、typeField 缺失情况
  // model.id = model.id || model.idField;
  model.type = model.type || model.typeField;
  model.typeField = model.type || model.typeField;

  if (model.type === shapeTypeConst.iconFont) {
    model.style.fill = '#000';
    model.labelCfg.offset = 5;

    if (!Object.hasOwn(model, 'backgroundConfig')) {
      model.backgroundConfig = {
        backgroundType: shapeTypeConst.rect,
        stroke: '#cde0f6',
        fill: '#e1edfb'
      };
    }
  }

  if (model.type === shapeTypeConst.image || model.type === shapeTypeConst.customImage) {
    delete model.style.fill;
    model.img = model.iconContent;
  }
}


/**
 * 拓扑插件-节点-处理自定义节点扩展样式变更
 * @param shape 节点图形对象
 * @param stateStyle 对应状态样式
 */
export function handleStateStyleChange(shape, stateStyle) {
  // 更新样式
  const shapeName = shape?.get('name') || '';
  let shapeStyle;
  if (stateStyle && Object.hasOwn(stateStyle, shapeName)) {
    shapeStyle = {...stateStyle, ...stateStyle[shapeName]};
    delete shapeStyle[shapeName];
  }

  if (shape) {
    shape.attr(shapeStyle);
  }
}
